<div class="container">
	<div class="login">
		<h1>Sign in</h1>
		
		<form [formGroup]="loginForm" (ngSubmit)="submit()">

			<div class="form-floating mb-3">
				<input type="text" class="form-control" id="username" placeholder="Passcode" formControlName="username" required>
				<label for="username">Passcode *</label>
			</div>

			<!-- @if (loginForm.controls.username.invalid && loginForm.controls.username.touched) {
				<p role="alert">Enter your username.</p>
			} -->

			@if (errorMessage(); as error) {
				<p class="error-message" role="alert">{{ error }}</p>
			}

			<button class="btn btn-primary" type="submit" [disabled]="isSubmitting()">
				{{ isSubmitting() ? 'Signing in...' : 'Sign in' }}
			</button>
		</form>
	</div>
</div>